module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_a-function.js
// module id = 60
// module chunks = 168707334958949